module.exports = "/_next/static/images/reference-cafourek-e43f9cae124ceabbe7bc08a8b62331d9.jpg";